import { CartPage } from '@/@types/content';

export const MyCartLabels = (cartPageData?: CartPage) => {
  return {
    outOfStockText:
      cartPageData?.outOfStockText ||
      'This item is temporarily out of stock. You can still place your order, and we’ll ship it as soon as it becomes available.',
    preOrderText:
      cartPageData?.preOrderText ||
      'This is a pre-order item. Continue with your purchase and your item will be delivered when it becomes available.',
    invalidQuantityText: 'Please only use numbers.',
    POECLiveWebcastText:
      cartPageData?.['poecLiveWebcastText' as keyof CartPage] ||
      'Access to the online version of the Patent Office Exam Course Online included.'
  };
};
